import { createSignal } from "solid-js";

import { registerSW } from "virtual:pwa-register";

const [pendingUpdate, setPendingUpdate] = createSignal<() => void>();

export { pendingUpdate };

if (import.meta.env.PROD) {
  let registration: ServiceWorkerRegistration | undefined;

  const updateSW = registerSW({
    onNeedRefresh() {
      setPendingUpdate(() => void updateSW(true));
    },
    onOfflineReady() {
      console.info("Ready to work offline =)");
      // toast to users
    },
    onRegistered(r) {
      registration = r;

      // Check for updates every hour
      setInterval(() => r!.update(), 36e5);
    },
  });

  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) {
      registration?.update();
    }
  });
}
